/**
 * Breadcrumb — globally disabled per owner directive (Feb 2026).
 *
 * Originally rendered a `Home / ...` row above every bespoke page hero.
 * Owner requested all pages drop the breadcrumb so the hero sits higher
 * and flows directly under the site header. We keep the component
 * (and its callers) intact but return `null` here so every page collapses
 * the breadcrumb area to zero height without touching 7 page files.
 *
 * The component still accepts the same props so existing imports/usage
 * remain valid and revertable in a single edit if needed.
 */
export default function Breadcrumb() {
  return null;
}
